import { SubPageShell } from "@/components/SubPageShell";
import { Booking } from "@/components/Booking";

export default function BookPage() {
  return (
    <SubPageShell
      eyebrow="Book your stay"
      title={<>Send AJ &amp; Brad <em>a request.</em></>}
      intro="Ata House is request-to-book — no payment is taken on this site. Choose your dates, share a few details, and we'll personally confirm within 24–48 hours."
    >
      <Booking hideHeader />
    </SubPageShell>
  );
}
